/* Polsk katalog for locale-firm-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('pl', {
  'rf.loading.firm': 'Wczytywanie Twojego biura …',
  'rf.loading.clients': 'Pobieranie Twoich klientów …',
  'rf.loading.reconciliation': 'Pobieranie uzgodnień …',
  'rf.loading.control': 'Pobieranie zadań kontrolnych …',
  'rf.loading.ledger': 'Wczytywanie księgowości klienta …',
  'rf.pageError.title': 'Nie udało się wczytać strony',
  'rf.pageError.text': 'Wczytaj ponownie widok biura. Jeśli problem się powtarza, skrypt tej strony jest niedostępny.',
  'rf.client.assignCount': 'Przypisz ({count})',
  'rf.client.assignAll': 'Wszyscy w biurze',
  'rf.client.assignNobody': 'Biuro nie ma jeszcze aktywnych pracowników do przypisania do zlecenia.',
  'rf.client.assignRoleHint': 'Rola dotyczy wszystkich zaznaczonych osób. Osoby już przypisane otrzymają nową rolę.',
  'rf.client.assignedMany': 'Pracownicy przypisani do zlecenia: {count}',
  'rf.nav.myPage': 'Moja strona',
  'rf.nav.firmBooks': 'Do księgowości biura',
});
